import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController, ToastController, ModalController } from 'ionic-angular';
import { EventData } from '../../providers/event';
import { TranslateService } from '@ngx-translate/core';
import { Database } from '../../providers/database';
import { Translate } from '../../providers/translate';
import { AuthData } from '../../providers/auth';
import { Catalog } from './catalog/catalog';
import { LoginPage } from '../login/login';
import { EventCart } from '../event-cart/event-cart';
import { Observable} from 'rxjs/Observable';

@Component({
  selector: 'page-event-catalogs',
  templateUrl: 'event-catalogs.html',
})
export class EventCatalogs {

  obs: any;
  obsCatalog: any;
  obsRelatedCatalog: any;
  obsBadgeCatalog: any;
  dataCatalogs: any;
  badgeCatalogUser: any = [];
  client: any;
  event: any;
  textTranslate: any;

  constructor(public navCtrl: NavController, public params: NavParams, public db: Database, public eventProvider: EventData, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public translateProvider: TranslateService, translate: Translate, public toastCtrl: ToastController, public auth: AuthData, public modalCtrl: ModalController) {
    translate.translateGroup(['Cargando', 'Se ha agregado el producto al carrito de compra', 'Ingrese la cantidad de items', 'Número de items', 'Cancelar', 'Aceptar', 'Debe iniciar sesión antes de continuar']).
    then(result => {
      this.textTranslate = result;
    });

    this.client = this.params.get('client');
    this.event = this.params.get('event');

    this.obs = new Observable(observer => {
      this.obsCatalog = this.eventProvider.getCatalogs(this.client, this.event.id).subscribe(data => {
        if (data) {
          observer.next(data);
        } else {
          observer.next(false);
        }
      });
    });

    this.obs.subscribe((value) => {
      this.dataCatalogs = false;

      if (this.obsRelatedCatalog) {
        this.obsRelatedCatalog.unsubscribe();
      }

      if (value) {
        value.forEach((catalog: any, key) => {
          this.obsRelatedCatalog = this.eventProvider.getCatalog(this.client, catalog.catalogId).subscribe((data: any) => {
            value[key] = data;
          });
        });

        this.dataCatalogs = value;
      } else {
        this.dataCatalogs = false;
      }
    });

    if (!this.auth.getUser().isAnonymous) {
      this.obsBadgeCatalog = this.eventProvider.getCatalogBadge(this.client, this.auth.getUser().uid).subscribe((data) => {
        this.badgeCatalogUser = data;
      });
    }
  }

  viewCart() {
    if (!this.auth.getUser().isAnonymous) {
      this.navCtrl.push(EventCart, {client: this.client, event: this.event});
    } else {
        let modal = this.modalCtrl.create(LoginPage, {client: this.client, event: this.event});
        modal.present();

        let toast = this.toastCtrl.create({
          message: this.textTranslate["Debe iniciar sesión antes de continuar"],
          duration: 5000,
          position: 'top'
        });
        toast.present();
    }
  }

  viewItem(catalog, addToPay=false) {
    this.navCtrl.push(Catalog, {client: this.client, event: this.event, dataCatalog: catalog, addToPay: addToPay});
  }

  closeListener() {
    if (this.obsCatalog) {
      console.log('Se eliminan los observables de event CatalogsPage');
      this.obsCatalog.unsubscribe();
    }
    if (this.obsRelatedCatalog) {
      this.obsRelatedCatalog.unsubscribe();
    }
    if (this.obsBadgeCatalog) {
      this.obsBadgeCatalog.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-catalogs/event-catalogs.ts